<template>

    <div class="container">
        <h3 class="padding">Unfortunately there's a problem with the Artwork</h3>
        <h3>please contact Jupix support</h3>
        <p class="padding">{{pdfArtowrk}}</p>

        <div class="padding">
            <p>Please close this window</p>
        </div>

    </div>

</template>

<script>

    export default {
        name: "NoArtwork",
        components: {},
        data() {
            return {
                pdfArtowrk: ''
            }
        },
        created() {

            this.pdfArtowrk = window.sessionStorage.getItem('_filename')
        },
        methods: {
        }
    };
</script>